import styled from '@emotion/styled';
import { TextField as MuiTextField, Theme } from '@mui/material';

export const TextField = styled(MuiTextField)(
  ({ theme }: { theme?: Theme }) => `
    .MuiInputBase-root {
      background-color: ${theme?.palette.background.paper};
    }
  `
);
